var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgOutlineArrowLeft = function SvgOutlineArrowLeft(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-24": 20,
    viewBox: "0 0 19.5 15.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.463 15.425a.7.7 0 0 0 .287.056.74.74 0 0 0 .53-.22.75.75 0 0 0 0-1.06l-5.72-5.72h16.19a.75.75 0 1 0 0-1.5H2.56l5.72-5.72A.75.75 0 0 0 7.22.201L.239 7.182a.75.75 0 0 0 0 1.098l6.981 6.981a.7.7 0 0 0 .243.164",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOutlineArrowLeft);
export default ForwardRef;